import React from 'react';
import { css } from '@emotion/core';
import Delivery from '../../Icons/Delivery';
import FreeDelivery from '../../Icons/FreeDelivery';
import Price from '../../Price/Price';

const DeliveryInfo = ({
  shippingDescription,
  freeShippingThreshold,
  topHeaderSecondaryVersion,
  primaryColor,
  secondaryColor,
}) => {
  const deliveryInfoStyle = css`
    display: flex;
    align-items: center;
    gap: 30px;

    & .delivery-info {
      display: flex;
      gap: 4px;
      & svg path {
        fill: ${primaryColor};
      }
      & div {
        color: ${!!topHeaderSecondaryVersion ? '#222222' : '#ffff'};
        font-size: 12px;
        display: flex;
        gap: 3px;
      }
    }
  `;

  return (
    <div className="delivery-info-container" css={deliveryInfoStyle}>
      <div className="delivery-info">
        <Delivery />

        <div>{shippingDescription}</div>
      </div>

      <div className="delivery-info">
        <FreeDelivery />
        Spedizione gratuita sopra i <Price amount={freeShippingThreshold} />
      </div>
    </div>
  );
};
export default DeliveryInfo;
